import React, { useRef } from 'react';
import {
  ErrorBoundary,
  SearchProvider,
  WithSearch,
} from '@elastic/react-search-ui';
import { Layout } from '@elastic/react-search-ui-views';
import '@elastic/react-search-ui-views/lib/styles/styles.css';
import { Box, CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';
import config from '../../config/elastic';
import { Filter, Footer, Header, ResultsBody } from '../../components';
import { FilterContextProvider } from '../../context/filter';
import ScrollPagination from '../../utils/scrollPagination';

export const Search = () => {
  const refResults = useRef(null);
  const refFilterHeader = useRef(null);
  const location = useLocation();
  (window as any).showInitiative = (location as any).state?.showInitiative;

  return (
    <SearchProvider config={config}>
      <WithSearch
        mapContextToProps={({
          totalResults,
          setSearchTerm,
          facets,
          setFilter,
          removeFilter,
          isLoading,
        }) => ({
          totalResults,
          setSearchTerm,
          facets,
          setFilter,
          removeFilter,
          isLoading,
        })}
      >
        {({
          totalResults,
          setSearchTerm,
          facets,
          setFilter,
          removeFilter,
          isLoading,
        }) => {
          /* TO DO: CREATE CONTEXT - IMPROVEMENT */
          (window as any).cf_department =
            facets.cf_department && facets.cf_department[0].data;
          (window as any).cf_brand = facets.cf_brand && facets.cf_brand[0].data;
          (window as any).cf_category =
            facets.cf_category && facets.cf_category[0].data;
          (window as any).location_city =
            facets.location_city && facets.location_city[0].data;
          (window as any).setFilter = setFilter;
          (window as any).removeFilter = removeFilter;
          (window as any).setSearchTerm = setSearchTerm;
          return (
            <Box className="App">
              <ErrorBoundary>
                <FilterContextProvider>
                  <Layout
                    header={
                      <Header
                        refResults={refResults}
                        refFilterHeader={refFilterHeader}
                      />
                    }
                    sideContent={<Filter />}
                    bodyContent={
                      isLoading ? (
                        <Box
                          minHeight="200px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <CircularProgress />
                        </Box>
                      ) : (
                        <ResultsBody
                          total={totalResults}
                          refResults={refResults}
                          refFilterHeader={refFilterHeader}
                        />
                      )
                    }
                    bodyFooter={
                      !(window as any).showInitiative &&
                      !isLoading && (
                        <>
                          <ScrollPagination />
                          <Footer />
                        </>
                      )
                    }
                  />
                </FilterContextProvider>
              </ErrorBoundary>
            </Box>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
};
